import {
  ionLogoFacebook,
  ionLogoInstagram,
  ionLogoTiktok,
} from '@ng-icons/ionicons';
import {
  matAdd,
  matAdminPanelSettings,
  matAltRoute,
  matArrowCircleLeft,
  matArrowCircleRight,
  matArrowDropDown,
  matArrowForward,
  matAttachFile,
  matAccountBalance,
  matAttachMoney,
  matBallot,
  matBolt,
  matCalculate,
  matCalendarMonth,
  matCalendarToday,
  matCallMerge,
  matCancel,
  matCategory,
  matChat,
  matCheck,
  matCheckCircle,
  matChevronLeft,
  matChevronRight,
  matClose,
  matColorLens,
  matCreditCard,
  matDashboard,
  matDateRange,
  matDescription,
  matDirectionsCar,
  matDiscount,
  matDownload,
  matDragIndicator,
  matDriveFileRenameOutline,
  matEdit,
  matEmail,
  matExpandLess,
  matExpandMore,
  matFeed,
  matFileDownload,
  matFilePresent,
  matFilterAltOff,
  matFilterNone,
  matFolderZip,
  matHome,
  matHomeRepairService,
  matImage,
  matInfo,
  matInsertDriveFile,
  matInventory2,
  matKey,
  matKeyboardArrowDown,
  matKeyboardArrowRight,
  matKeyboardArrowUp,
  matLink,
  matLocationOn,
  matOpenInNew,
  matLogOut,
  matManageAccounts,
  matMonetizationOn,
  matNotifications,
  matPayment,
  matPeople,
  matPercentage,
  matPerson,
  matPhoneAndroid,
  matPlaylistAddCheckCircle,
  matPlus,
  matPriceChange,
  matQuestionMark,
  matRealEstateAgent,
  matRecordVoiceOver,
  matRequestQuote,
  matSafetyCheck,
  matSave,
  matSearch,
  matSearchOff,
  matKeyboardReturn,
  matSell,
  matSend,
  matStar,
  matStarBorder,
  matStickyNote2,
  matSubject,
  matSync,
  matTag,
  matTimelapse,
  matLabel,
  matRule,
  matTitle,
  matTune,
  matUploadFile,
  matViewColumn,
  matViewList,
  matVisibility,
  matWarning,
  matWork,
  matPendingActions,
  matFactCheck,
  matDocumentScanner as matDocumentScannerFillRound,
  matFindInPage as matDocumentSearchFillOutline,
  matShield as matShieldFillOutline,
  matDirectionsBoat,
  matFactory,
  matFlag,
  matPrecisionManufacturing,
  matPictureAsPdf,
  matSwapVert,
  matUndo,
  matPhoneIphone,
  matUnfoldMore,
  matUnfoldLess,
  matContentCopy,
  matZoomIn,
  matZoomOut,
  matRotateRight,
  matHistory,
  matComputer,
} from '@ng-icons/material-icons/baseline';
import {
  matAdminPanelSettingsOutline,
  matBallotOutline,
  matCalculateOutline,
  matCalendarMonthOutline,
  matColorLensOutline,
  matDarkModeOutline,
  matDirectionsCarOutline,
  matCheckCircleOutline,
  matDiscountOutline,
  matFeedOutline,
  matHomeOutline,
  matHomeRepairServiceOutline,
  matInfoOutline,
  matInsertDriveFileOutline,
  matInventory2Outline,
  matLightModeOutline,
  matLockOutline,
  matLogoutOutline,
  matMailOutline,
  matMonetizationOnOutline,
  matNotificationAddOutline,
  matPaymentOutline,
  matPlaylistAddCheckCircleOutline,
  matNotificationsNoneOutline,
  matPersonOutline,
  matPriceChangeOutline,
  matRealEstateAgentOutline,
  matSafetyCheckOutline,
  matSettingsOutline,
  matWorkOutline as matWorkOutlineOutline,
  matPendingActionsOutline,
  matDocumentScannerOutline as matDocumentScannerRound,
  matFindInPageOutline as matDocumentSearchOutline,
  matSwapVertOutline,
} from '@ng-icons/material-icons/outline';
import {
  matGarageSharp as matGarageMoneySharp,
  matGarageSharp as matGarageMoneyFillSharp,
} from '@ng-icons/material-icons/sharp';
import {
  phosphorAppStoreLogoBold,
  phosphorGooglePlayLogoBold,
} from '@ng-icons/phosphor-icons/bold';
import { phosphorSteeringWheelFill } from '@ng-icons/phosphor-icons/fill';
import {
  phosphorEngine,
  phosphorGasPump,
  phosphorIdentificationCard,
  phosphorSteeringWheel,
} from '@ng-icons/phosphor-icons/regular';

export const GLOBAL_ICONS = {
  // Material Icons (Baseline)
  matAdminPanelSettings,
  matBallot,
  matCalculate,
  matClose,
  matColorLens,
  matCreditCard,
  matDirectionsCar,
  matDiscount,
  matExpandLess,
  matExpandMore,
  matFeed,
  matHome,
  matHomeRepairService,
  matInfo,
  matInsertDriveFile,
  matLogOut,
  matMonetizationOn,
  matNotifications,
  matPayment,
  matPerson,
  matTitle,
  matSubject,
  matSave,
  matLabel,
  matRule,
  matTune,
  matPeople,
  matSend,
  matCalendarMonth,
  matChevronRight,
  matPercentage,
  matRequestQuote,
  matPlus,
  matKeyboardArrowUp,
  matKeyboardArrowDown,
  matKeyboardArrowRight,
  matViewColumn,
  matViewList,
  matDashboard,
  matEdit,
  matDateRange,
  matImage,
  matVisibility,
  matAttachFile,
  matDownload,
  matFolderZip,
  matEmail,
  matManageAccounts,
  matCalendarToday,
  matPhoneAndroid,
  phosphorIdentificationCard,
  matLocationOn,
  matLink,
  matOpenInNew,
  matSell,
  matChevronLeft,
  matArrowCircleLeft,
  matArrowCircleRight,
  matCheckCircle,
  matFilePresent,
  matTimelapse,
  matUploadFile,
  matSync,
  matSearch,
  matSearchOff,
  matKeyboardReturn,
  matFilterAltOff,
  matFilterNone,
  matFileDownload,
  matCancel,
  matDragIndicator,
  matAccountBalance,
  matAttachMoney,
  matCheck,
  matRealEstateAgent,
  matPriceChange,
  matQuestionMark,
  matWarning,
  matChat,
  matCallMerge,
  matCategory,
  matKey,
  matAdd,
  matRecordVoiceOver,
  matBolt,
  matArrowForward,
  matArrowDropDown,
  matAltRoute,
  matTag,
  matDescription,
  matStar,
  matStarBorder,
  matStickyNote2,
  matInventory2,
  matSafetyCheck,
  matPlaylistAddCheckCircle,
  matWork,
  matPendingActions,
  matFactCheck,
  matDocumentScannerFillRound,
  matDocumentSearchFillOutline,
  matShieldFillOutline,
  // Material Icons (Outline)
  matAdminPanelSettingsOutline,
  matBallotOutline,
  matCalculateOutline,
  matColorLensOutline,
  matDarkModeOutline,
  matDirectionsCarOutline,
  matCheckCircleOutline,
  matDiscountOutline,
  matFeedOutline,
  matHomeOutline,
  matHomeRepairServiceOutline,
  matInfoOutline,
  matInsertDriveFileOutline,
  matLightModeOutline,
  matLogoutOutline,
  matMonetizationOnOutline,
  matNotificationsNoneOutline,
  matPaymentOutline,
  matPersonOutline,
  matSettingsOutline,
  matMailOutline,
  matLockOutline,
  matNotificationAddOutline,
  matDriveFileRenameOutline,
  matCalendarMonthOutline,
  matRealEstateAgentOutline,
  matPriceChangeOutline,
  matInventory2Outline,
  matSafetyCheckOutline,
  matPlaylistAddCheckCircleOutline,
  matWorkOutlineOutline,
  matPendingActionsOutline,
  matDocumentScannerRound,
  matDocumentSearchOutline,
  // Material Icons (Sharp)
  matGarageMoneySharp,
  matGarageMoneyFillSharp,
  // Phosphor Icons
  phosphorSteeringWheelFill,
  phosphorSteeringWheel,
  phosphorAppStoreLogoBold,
  phosphorGooglePlayLogoBold,
  phosphorEngine,
  phosphorGasPump,
  // Ionicons
  ionLogoInstagram,
  ionLogoTiktok,
  ionLogoFacebook,
  matDirectionsBoat,
  matFactory,
  matFlag,
  matPrecisionManufacturing,
  matPictureAsPdf,
  matSwapVert,
  matSwapVertOutline,
  matUndo,
  matPhoneIphone,
  matUnfoldMore,
  matUnfoldLess,
  matContentCopy,
  matZoomIn,
  matZoomOut,
  matRotateRight,
  matHistory,
  matComputer,
};
